import cn from "classnames";
import CTA from "@/ui/CTA";

// eslint-disable-next-line import/no-anonymous-default-export,react/display-name
export default function ({ className = "d-flex gap-3", buttons = [] }) {
  if (buttons.length === 0) return null;

  return (
    <div className={cn(className)}>
      {buttons.map((button, idx) => (
        <CTA
          key={idx}
          className={button?.className}
          label={button?.label}
          href={button?.href}
          target={button?.href.startsWith("http") ? "_blank" : "_self"}
          variant={button?.variant}
        />
      ))}
    </div>
  );
}
